<template>
  <v-col lg="3" md="6" cols="12">
    <li class="menu-container__items">
      <div class="menu-container__item-title">
        <a
          v-if="menuItem.blockTitle.url"
          :href="menuItem.blockTitle.url"
          class="menu-container__items-link"
          v-html="menuItem.blockTitle.title"
        />
        <span
          v-else
          v-html="menuItem.blockTitle.title"
        />
      </div>
      <ul class="menu-container__subitems">
        <li
          v-for="(item, index) in menuItem.items"
          :key="index"
          class="menu-container__subitems-items"
        >
          <a
            :href="item.url"
            class="menu-container__subitems-items-link"
            v-html="item.title"
          />
        </li>
      </ul>
    </li>
  </v-col>
</template>

<script>
  export default {
    name: 'TheMenuBlock',

    props: {
      menuItem: {
        required: true,
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  ul
    padding: 0

    li
      text-decoration: none
      list-style-type: none


  .menu-container__item-title
    font-size: 28px
    border-bottom: 1.5px solid $dark-text-color
    color: $dark-text-color
    font-weight: bold
    margin-bottom: 16px

  .menu-container__subitems-items
    padding: 4px 0
    font-size: 14px

  .menu-container__subitems-items-link
    text-decoration: none
    color: $dark-text-color
    border-bottom: 1px solid transparent
    transition: border-color 0.45s cubic-bezier(0.65, 0, 0.08, 1)

    &:hover
      opacity: 0.8
      border-bottom: 1px solid $dark-text-color

  .menu-container__items-link
    text-decoration: none
    color: $dark-text-color
    transition: border-color 0.45s cubic-bezier(0.65, 0, 0.08, 1)

    &:hover
      opacity: 0.8
</style>
